/** Complimentary Creator Plan access granted by admin (no Stripe). */

export type CompAccessCreatorFacts = {
  compAccessGrantedAt?: Date | string | null;
  disabled?: boolean;
};

export function hasComplimentaryCreatorAccess(creator: CompAccessCreatorFacts): boolean {
  return Boolean(creator.compAccessGrantedAt) && !creator.disabled;
}

export type CreatorEntitlementInput = {
  disabled: boolean;
  hasStripeAccess: boolean;
  hasCompAccess: boolean;
};

/** Resolve setupStatus after entitlement / moderation changes (not past_due). */
export function resolveCreatorSetupAfterEntitlementChange(
  input: CreatorEntitlementInput,
): 'active' | 'canceled' | 'suspended' {
  if (input.disabled) return 'suspended';
  if (input.hasStripeAccess || input.hasCompAccess) return 'active';
  return 'canceled';
}

/** True when Stripe rows or complimentary grant entitle Creator Plan access. */
export function hasCreatorPlanEntitlement(input: {
  hasStripeAccess: boolean;
  creator: CompAccessCreatorFacts | null | undefined;
}): boolean {
  if (!input.creator || input.creator.disabled) return false;
  if (hasComplimentaryCreatorAccess(input.creator)) return true;
  return input.hasStripeAccess;
}
